import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DebitoService } from 'app/services/debito.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { AddDebitoAutoComponent } from 'app/modals/debito-auto/add-debito-auto/add-debito-auto.component';
import { DebitoAutomatico } from 'app/entities/debito-automatico';
import { element } from 'protractor';
import { HistoricoFacturasComponent } from 'app/modals/cartera/historico-facturas/historico-facturas.component';

@Component({
  selector: 'app-registrar-debito-auto',
  templateUrl: './registrar-debito-auto.component.html',
  styleUrls: ['./registrar-debito-auto.component.scss']
})
export class RegistrarDebitoAutoComponent implements OnInit, AfterViewInit {

  public dtOptions: any;
  public tableOpt: Array<DebitoAutomatico> = [];
  @ViewChild(DataTableDirective, {static: true})
  tabla: DataTableDirective;
  public dtTrigger: Subject<void> = new Subject();

  select_option: any;
  public checkbox_checked: boolean = false;
  select_debito: Array<any> = [];

  constructor
  (
    private _debito: DebitoService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) 
  { 
    this.dtTrigger.next();
    this.dtOptions = {
      order: [2, 'asc'],
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      responsive: true, 
      autoWidth: false,
      columns: [
        {
          orderable: false,
          targets: 0
        },
        {
          orderable: false,
          targets: 1
        },
        {
          data: 'empresa'
        },
        {
          data: 'nombre_grupo'
        },
        {
          data: 'documento_grupo'
        },
        {
          data: 'radicado_grupo'
        },
        {
          data: 'debitoPeriodo'
        },
        {
          data: 'saldo_total'
        },
        {
          render: (data, type, row, meta) =>{
            return `<a>${data}</a>`
          }
        },
        {
          data: 'debitos_pendientes'
        },
        {
          data: 'banco'
        },
        {
          data: 'sucursal'
        },
        {
          data: 'tipo_cuenta',
          class: 'none'
        },
        {
          data: 'no_cuenta',
          class: 'none'
        },
        {
          data: 'documento',
          class: 'none'
        },
        {
          data: 'titular_cuenta',
          class: 'none'
        }
      ]
    }
  }

  ngOnInit() {
    this.busquedaxPeriodo();
  }

  public busquedaxPeriodo(opcion?: string){
    this.select_option = opcion ? opcion : '';
    this._debito.VerGruposxPeriodoDebito(opcion).subscribe((data: Array<DebitoAutomatico>) => {
      this.tableOpt = data;
      this.renderer();
    });
  }

  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  public updateDebitoAuto(index: string){
    let modal: any;
    modal = this.dialog.open(AddDebitoAutoComponent, {
      width: '45%',
      height: '60%',
      panelClass: 'custom-dialog-container',
      data: {
        base_datos: this.tableOpt[index].empresa === 'VitalMascotas' ? 'medisoftvet' : 'medisoft',
        grupo: this.tableOpt[index].ID_Grupo
      }
    });

    modal.afterClosed().subscribe((result: boolean) => {
      if(result) this.busquedaxPeriodo(this.select_option);
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  public selectAll(checked: boolean): void{
    this.checkbox_checked = checked; //Marca todos los checkbox como 'checked'
    if(checked){
      this.tableOpt.forEach(element => {
        this.addDebito_Array(element);
      });
    }else{
      this.select_debito.forEach(element => {
        this.deleteDebito_Array(element);
      });
    }
  }

  public addDebito_Array(debito: DebitoAutomatico): void {
    if(!this.validationDebito_Array(debito)) this.select_debito.push(debito);
    return;
  }

  public deleteDebito_Array(debito: DebitoAutomatico): void{
    if(this.validationDebito_Array(debito)){
      let index: number = this.select_debito.indexOf(debito);
      this.select_debito.splice(index);
    }
    return;
  }

  validationDebito_Array(debito: DebitoAutomatico): boolean{ 
    return this.select_debito.includes(debito);
  }

  public guardarDebitos(debitos: Array<DebitoAutomatico>): void {

    debitos.forEach(element => {
      element['empresa'] = element.empresa === 'VitalMascotas' ? '2' : '1';
      element['usuario_login'] = JSON.parse(localStorage.getItem('usuario'))['id_usuario'];
    });

    this._debito.GuardarDebitos(debitos).subscribe((data: any) => {
      if(data){
        this._snackBar.open('Débitos Registrados', 'Aceptar', {
          duration: 2500
        });
      }else{
        this._snackBar.open('Error al registrar los débitos', '', {
          panelClass: 'warn-600',
          duration: 2500
        });
      }
    });
  }

  public modalHistoriaLlamadas(grunit: string, grugru: string, empresa: string){
    this.dialog.open(HistoricoFacturasComponent, {
      data: {
        grunit: grunit,
        grugru: grugru,
        base_datos: empresa === 'VitalMascotas' ? 'medisoftvet' : 'medisoft'
      }
    });
  }
}
